import cc from 'classcat';
import { always } from 'ramda';

import { fromCents } from '#src/lib/formatters/numbers';

import styles from './styles.module.scss';

const PaymentPlanChoice = ({
  amount,
  className,
  code,
  name,
  onChange,
  selected,
  subscription,
  theme,
}) => {
  const handleChange = () => onChange({ code, amount });

  return (
    <label
      className={cc([
        { [styles.selected]: selected },
        styles[theme],
        styles.container,
        className,
      ])}
    >
      <div className={styles.radio}>
        <input
          name={name}
          value={code}
          type="radio"
          checked={selected}
          onChange={handleChange}
        />
      </div>
      <div className={styles.amount}>{fromCents(amount || 0)}</div>
      <p className={styles.description}>
        {!subscription ? 'Pay upfront' : 'Pay monthly'}
      </p>
      {!subscription && <p className={styles.bonus}>One month free!</p>}
    </label>
  );
};

PaymentPlanChoice.defaultProps = {
  theme: 'waybetter',
  selected: false,
  onChange: always(undefined),
};

export default PaymentPlanChoice;
